import { Input, Directive, Output, EventEmitter, ElementRef } from '@angular/core';
import { DragulaService, dragula } from 'ng2-dragula';
/**
 * Директива сортировки Drag'n'Drop
 */
var DDSortDirective = /** @class */ (function () {
    function DDSortDirective(dragulaService, el) {
        this.dragulaService = dragulaService;
        this.el = el;
        /**
         * Событие происходящее при действии 'drop'. Параметры в виде объекта, где:
         *      bagName - Имя корзины
         *      el      - Элемент который был захвачен
         *      target  - Элемент в который был перемещен захваченый элемент
         *      source  - Элемент из которого был перемещен захваченый элемент
         *      sibling - Элемент перед которым был помещен захваченый элемент (null - если в конец списка)
         * @type {EventEmitter<DDSortDropResponse>}
         */
        this.ddDrop = new EventEmitter();
        /**
         * Подписки на события dragulaService-а
         * @type {Array}
         */
        this.subscriptions = [];
        this.container = el.nativeElement;
    }
    /**
     * Инициализация компонента
     */
    DDSortDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.bag = this.dragulaService.find(this.bagName);
        if (this.bag) {
            this.drake = this.bag.drake;
            this.drake.containers.push(this.container);
        }
        else {
            this.drake = dragula([this.container], {
                revertOnSpill: true,
                moves: function (el, source, handle) {
                    return (_this.dragClass) ? handle.classList.contains(_this.dragClass) : true;
                }
            });
            this.dragulaService.add(this.bagName, this.drake);
        }
        this.subscriptions.push(this.dragulaService.drop.subscribe(function (value) {
            value = value || [];
            var bagName = value[0] || '';
            if (bagName === _this.bagName) {
                _this.ddDrop.emit({
                    bagName: bagName,
                    el: value[1] || null,
                    target: value[2] || null,
                    source: value[3] || null,
                    sibling: value[4] || null
                });
            }
        }));
    };
    /**
     * Уничтожение компонента
     */
    DDSortDirective.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) {
            sub.unsubscribe();
        });
        this.dragulaService.destroy(this.bagName);
    };
    DDSortDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[gp-dd-sort]'
                },] },
    ];
    /** @nocollapse */
    DDSortDirective.ctorParameters = function () { return [
        { type: DragulaService, },
        { type: ElementRef, },
    ]; };
    DDSortDirective.propDecorators = {
        'bagName': [{ type: Input, args: ['ddSortName',] },],
        'dragClass': [{ type: Input, args: ['ddDragClass',] },],
        'ddDrop': [{ type: Output },],
    };
    return DDSortDirective;
}());
export { DDSortDirective };
//# sourceMappingURL=dd-sort.directive.js.map